/**
 * @generated SignedSource<<090a8ec95dfdadd47bec89018f875146>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IterationFieldFragment$data = {
  readonly duration: number;
  readonly field: {
    readonly configuration?: {
      readonly completedIterations: ReadonlyArray<{
        readonly duration: number;
        readonly id: string;
        readonly startDate: any;
        readonly title: string;
        readonly titleHTML: string;
      }>;
      readonly iterations: ReadonlyArray<{
        readonly duration: number;
        readonly id: string;
        readonly startDate: any;
        readonly title: string;
        readonly titleHTML: string;
      }>;
    };
    readonly id?: string;
    readonly name?: string;
  };
  readonly iterationId: string;
  readonly startDate: any;
  readonly title: string;
  readonly titleHTML: string;
  readonly " $fragmentType": "IterationFieldFragment";
};
export type IterationFieldFragment$key = {
  readonly " $data"?: IterationFieldFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IterationFieldFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IterationFieldFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iterationId",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2IterationFieldConfiguration",
              "kind": "LinkedField",
              "name": "configuration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectV2IterationFieldIteration",
                  "kind": "LinkedField",
                  "name": "iterations",
                  "plural": true,
                  "selections": (v5/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectV2IterationFieldIteration",
                  "kind": "LinkedField",
                  "name": "completedIterations",
                  "plural": true,
                  "selections": (v5/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ProjectV2IterationField",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2ItemFieldIterationValue",
  "abstractKey": null
};
})();

(node as any).hash = "3fe0ed3cf83c5a892651ce7f71261a79";

export default node;
